"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const ethers_1 = require("ethers");
class EkcSigner extends ethers_1.Signer {
    constructor(provider) {
        super();
        this.provider = provider;
        this._ekc = undefined;
    }
    bindTo(ekc) {
        this._ekc = ekc;
        return this;
    }
    /////////////////////////////////////////////////////////////////////////////
    getAddress() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._ekc)
                throw new Error('EKC is not initialized!');
            const address = yield this._ekc._getProxy().getAddress();
            return address;
        });
    }
    signMessage(message) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._ekc)
                throw new Error('EKC is not initialized!');
            const signature = yield this._ekc._getProxy().signMessage(message);
            return signature;
        });
    }
    signTransaction(transaction) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._ekc)
                throw new Error('EKC is not initialized!');
            const signature = yield this._ekc._getProxy().signTransaction(transaction);
            return signature;
        });
    }
    connect(provider) {
        if (!this._ekc)
            throw new Error('EKC is not initialized!');
        const newEkcSigner = new EkcSigner(provider).bindTo(this._ekc);
        return newEkcSigner;
    }
    /////////////////////////////////////////////////////////////////////////////
    getBalance() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._ekc)
                throw new Error('EKC is not initialized!');
            const address = yield this._ekc._getProxy().getAddress();
            const balance = yield this.provider.getBalance(address);
            return balance;
        });
    }
    getTransactionCount() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._ekc)
                throw new Error('EKC is not initialized!');
            const address = yield this._ekc._getProxy().getAddress();
            const transactionCount = yield this.provider.getTransactionCount(address);
            return transactionCount;
        });
    }
    sendTransaction(transaction) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._ekc)
                throw new Error('EKC is not initialized!');
            if (!transaction.gasLimit) {
                const estimatedGas = yield this.estimateGas(transaction);
                transaction.gasLimit = estimatedGas.toHexString();
            }
            if (!transaction.gasPrice) {
                const gasPrice = yield this.getGasPrice();
                transaction.gasPrice = gasPrice.toHexString();
            }
            if (!transaction.nonce) {
                transaction.nonce = yield this.getTransactionCount();
            }
            const signedTransaction = yield this.signTransaction(transaction);
            const response = yield this.provider.sendTransaction(signedTransaction);
            return response;
        });
    }
    /////////////////////////////////////////////////////////////////////////////
    verifyMessage(message, signature) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._ekc)
                throw new Error('EKC is not initialized!');
            const pubKey = ethers_1.utils.verifyMessage(message, signature);
            return Promise.resolve(pubKey);
        });
    }
}
exports.default = EkcSigner;
